import { Styles, generateClasses } from 'netline-ui';

export const helpMenuItemClasses = generateClasses('HelpMenuItem', ['root', 'icon'] as const);
const styles: Styles = ({ theme: { spacing } }) => ({
  [`&.${helpMenuItemClasses.root}`]: {
    fontSize: 13,
    height: 32,
  },
  [`.${helpMenuItemClasses.icon}`]: {
    margin: spacing(0, 0.5),
  },
});

export default styles;
